import { createStore } from 'vuex'

import commsModules from '../../../../communication/sections/communication/store/comms-modules'
import buildComms from '../../../../communication/sections/communication/store/comms'
import remarkTags from '../../../../communication/sections/communication/store/remark-tags'
import { onEachPageTeardown } from '@app/adapters/page-teardown'

// TODO: Remove the singleton pattern when all stores are moved to Pinia
let store = null

function clearStore() {
  store = null
}

onEachPageTeardown(clearStore)

export default function createWorkflowStore(endpointParams, initialData = {}) {
  if (store) {
    return store
  }

  const comms = buildComms(endpointParams, initialData)

  store = createStore({
    modules: {
      ...commsModules,
    },

    state() {
      return {
        ...comms.state(),
      }
    },

    getters: {
      ...comms.getters,
    },
    actions: {
      ...comms.actions,
    },
    mutations: {
      ...comms.mutations,
    },
  })

  store.registerModule('remarkTags', remarkTags, { preserveState: true })

  return store
}
